import { render, staticRenderFns } from "./ship.vue?vue&type=template&id=ae332460&"
import script from "./ship.vue?vue&type=script&lang=js&"
export * from "./ship.vue?vue&type=script&lang=js&"
import style0 from "./ship.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports